import React, {Component} from 'react';
import {login, saveUserDetails} from '../services/UsersService';
import {Button, Form, Icon, Input, Modal} from 'antd';
import {Link} from 'react-router-dom';

const FormItem = Form.Item;

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            isLoading: false
        }
    }

    render() {
        const AntWrappedLoginForm = Form.create()(LoginForm);
        return (
            <div className="login-container">
                <h1 className="page-title">Login</h1>
                <div className="login-content">
                    <AntWrappedLoginForm onLogin={this.props.onLogin} username={this.state.username}/>
                </div>
            </div>
        );
    }
}

class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            isLoading: true
        });
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const loginRequest = Object.assign({}, values);
                login(loginRequest)
                    .then(response => {
                        saveUserDetails(response);
                        this.props.onLogin();
                    }).catch(error => {
                    this.error();
                });
            } else {
                this.setState({
                    isLoading: false
                });
            }
        });
    }

    error() {
        Modal.error({
            title: 'Credenciales incorrectas',
            content: 'El usuario o la contraseña son inválidos'
        });
        this.setState({
            isLoading: false
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div>
                <Form onSubmit={this.handleSubmit} className="login-form">
                    <FormItem>
                        {getFieldDecorator('id', {
                            rules: [{required: true, message: 'Campo obligatorio'}],
                            initialValue: this.props.username
                        })(
                            <Input
                                prefix={<Icon type="user"/>}
                                size="large"
                                name="id"
                                type="email"
                                placeholder={'Usuario'}/>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('pass', {
                            rules: [{required: true, message: 'Campo obligatorio'}],
                        })(
                            <Input
                                prefix={<Icon type="lock"/>}
                                size="large"
                                name="pass"
                                type="password"
                                placeholder={'Contraseña'}/>
                        )}
                    </FormItem>
                    <FormItem>
                        <Button type="primary" htmlType="submit" size="large" className="login-form-button"
                                icon="login" loading={this.state && this.state.isLoading}>
                            {'Ingresar'}
                        </Button>
                        <div className="custom-links">
                            <Link to={'/password_recover'}> {'¿Olvidó su usuario o contraseña?'}</Link>
                        </div>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/app/views/Login.js